import {
  $adminBlockUserModal,
  $adminChangePassModal,
  $adminCreateUserModal,
  $userLoginHistory,
  $userLoginTableProps,
  $usersList,
  $usersListTableProps,
  $usersLog,
  $usersLogsTableProps,
} from './stores.js';
import {
  blockUserFx,
  changeUserPasswordByAdminFx,
  createUserByAdminFx,
  getAdminLoginHistoryFx,
  getUserLoginHistoryFx,
  getUsersListFx,
  getUsersLogFx,
  unblockUserFx,
} from './effects.js';
import {
  blockUserEv,
  changeUserLoginTableEv,
  changeUserPasswordByAdminEv,
  changeUsersListTableEv,
  changeUsersLogTableEv,
  setAdminBlockUserModalEv,
  setAdminChangePassModalEv,
  setAdminCreateUserModalEv,
  submitAdminCreateUserEv,
  unblockUserEv,
  UserLoginHistoryGate,
  UsersListGate,
  UsersLogGate,
} from './events.js';
import { sample } from 'effector';
import { $userInfo } from '../authModel/index.js';
import queryString from 'query-string';
import notification from 'antd/es/notification';

$usersLog
  .on(getUsersLogFx.doneData, (_, payload) => payload)
  .reset(UsersLogGate.close);

$usersList
  .on(getUsersListFx.doneData, (_, payload) => payload)
  .reset(UsersListGate.close);

$userLoginHistory
  .on(
    [getAdminLoginHistoryFx.doneData, getUserLoginHistoryFx.doneData],
    (_, payload) => payload
  )
  .reset(UserLoginHistoryGate.close);

$userLoginTableProps
  .on(changeUserLoginTableEv, (state, payload) => ({ ...state, ...payload }))
  .reset(UserLoginHistoryGate.close);

$usersLogsTableProps
  .on(changeUsersLogTableEv, (state, payload) => ({ ...state, ...payload }))
  .reset(UsersLogGate.close);

$usersListTableProps
  .on(changeUsersListTableEv, (state, payload) => ({ ...state, ...payload }))
  .reset(UsersListGate.close);

$adminChangePassModal
  .on(setAdminChangePassModalEv, (state, payload) => ({ ...state, ...payload }))
  .reset(changeUserPasswordByAdminFx.doneData);

$adminCreateUserModal
  .on(setAdminCreateUserModalEv, (_, payload) => payload)
  .reset(createUserByAdminFx.doneData);

$adminBlockUserModal
  .on(setAdminBlockUserModalEv, (_, payload) => payload)
  .reset(blockUserFx.doneData);

sample({
  source: {
    user: $userInfo,
    gate: UserLoginHistoryGate.status,
    table: $userLoginTableProps,
  },
  clock: [UserLoginHistoryGate.status, $userLoginTableProps.updates],
  filter: (src) =>
    src.user.role === 'admin' || (src.user.role === 'superadmin' && !!src.gate),
  fn: (src) =>
    queryString.stringify(src.table, { skipNull: true, skipEmptyString: true }),
  target: getAdminLoginHistoryFx,
});

sample({
  source: {
    user: $userInfo,
    gate: UserLoginHistoryGate.status,
    table: $userLoginTableProps,
  },
  clock: [UserLoginHistoryGate.status, $userLoginTableProps.updates],
  filter: (src) =>
    src.user.role !== 'admin' && src.user.role !== 'superadmin' && !!src.gate,
  fn: (src) =>
    queryString.stringify(src.table, { skipNull: true, skipEmptyString: true }),
  target: getUserLoginHistoryFx,
});

sample({
  source: {
    gate: UsersLogGate.status,
    table: $usersLogsTableProps,
  },
  clock: [UsersLogGate.status, $usersLogsTableProps.updates],
  filter: (src) => !!src.gate,
  fn: (src) => {
    return queryString.stringify(src.table, {
      skipNull: true,
      skipEmptyString: true,
    });
  },
  target: getUsersLogFx,
});

sample({
  source: {
    gate: UsersListGate.status,
    table: $usersListTableProps,
  },
  clock: [
    UsersListGate.status,
    $usersListTableProps.updates,
    blockUserFx.doneData,
    unblockUserFx.doneData,
    createUserByAdminFx.doneData,
  ],
  filter: (src) => !!src.gate,
  fn: (src) => {
    return queryString.stringify(src.table, {
      skipNull: true,
      skipEmptyString: true,
    });
  },
  target: getUsersListFx,
});

sample({
  clock: blockUserEv,
  target: blockUserFx,
});

sample({
  clock: unblockUserEv,
  target: unblockUserFx,
});

sample({
  clock: changeUserPasswordByAdminEv,
  target: changeUserPasswordByAdminFx,
});

sample({
  clock: submitAdminCreateUserEv,
  target: createUserByAdminFx,
});

changeUserPasswordByAdminFx.doneData.watch(() =>
  notification.success({
    message: 'Успешно',
    description: 'Пароль пользователя изменен',
  })
);
